module.exports = __webpack_public_path__ + "img/fi-rr-search.fc732f90.svg";